import React, { useMemo } from 'react';
import { string, shape } from 'prop-types';
import { mergeClasses } from '../../classify';
import defaultClasses from './autocomplete.css';
import { X as Close } from 'react-feather';
import Icon from '../Icon';
import { useAutocompleteSearch } from '@magento/peregrine/lib/talons/Category/useAutocompleteSearch';
import { FormattedMessage } from 'react-intl';
import AutocompleteItem from './autocompleteItem';
import useMediaQuery from 'react-use-media-query-hook';
import { MEDIA_MAX_MOBILE } from '../../helpers/mediaQuery';
import { useAppContext } from '@magento/peregrine/lib/context/app';
import LoadingIndicator from "../LoadingIndicator";
import { useFooter } from "@magento/peregrine/lib/talons/Footer/useFooter";
import BBLink from "../BBLink";
var closeIcon = /*#__PURE__*/React.createElement(Icon, {
  src: Close,
  size: 32
});
export var stringValueExists = (str, searchValue) => {
  if (!str || !searchValue) return null;
  var filteredStr = str.toLowerCase().replace(/[^a-zA-Z]/g);
  var filteredSearchValue = searchValue.toLowerCase().replace(/[^a-zA-Z]/g);
  return filteredStr.includes(filteredSearchValue);
};
export var boldCurrentSearchBarValueStr = (str, searchValue) => {
  if (!str || !searchValue) return str;
  var matchIndex = str.toLowerCase().indexOf(searchValue.toLowerCase());
  if (matchIndex >= 0) {
    var existedString = str.substring(matchIndex, matchIndex + searchValue.length);
    var boldedSearch = str.slice(0, matchIndex) + "<b>".concat(existedString, "</b>") + str.slice(matchIndex + searchValue.length);
    return boldedSearch;
  }
  return str;
};
var Autocomplete = props => {
  var {
    outWrapperRef
  } = props;
  var [{
    searchBarValue,
    openSearchBar
  }, {
    setOpenSearchBar,
    closeAutocomplete
  }] = useAppContext();
  var {
    catDataRoot: categoryData
  } = useFooter();
  var isMaxMobile = useMediaQuery(MEDIA_MAX_MOBILE);
  var classes = mergeClasses(defaultClasses, props.classes);
  var {
    items,
    suggestions,
    popularSearch,
    productSearchLoading: loading,
    listRecentSearches,
    handleSuggestion,
    mseProductClick,
    mseSuggestionClick,
    mseCategoryClick
  } = useAutocompleteSearch();
  var matchingCategories = useMemo(() => {
    if (!categoryData || !categoryData.length || !searchBarValue) return null;
    var matchedCategories = [];
    for (var index = 0; index < categoryData.length; index++) {
      if (matchedCategories.length >= 5) {
        break;
      }
      var cat = categoryData[index];
      if (stringValueExists(cat.name, searchBarValue)) {
        matchedCategories.push(cat);
      }
    }
    return matchedCategories;
  }, [categoryData, searchBarValue]);
  var listSearches = useMemo(() => {
    var list = [];
    listRecentSearches && listRecentSearches.map((item, index) => {
      list.push( /*#__PURE__*/React.createElement("div", {
        key: index,
        className: classes.suggestItem
      }, /*#__PURE__*/React.createElement("button", {
        onClick: () => handleSuggestion(item),
        className: classes.suggestLink
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: item
        }
      }))));
    });
    return list;
  }, [listRecentSearches]);
  var listPopularSearch = useMemo(() => {
    var list = [];
    popularSearch && popularSearch.map((item, index) => {
      list.push( /*#__PURE__*/React.createElement("div", {
        key: index,
        className: classes.suggestItem
      }, /*#__PURE__*/React.createElement("button", {
        onClick: () => handleSuggestion(item),
        className: classes.suggestLink
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: item
        }
      }))));
    });
    return list;
  }, [popularSearch]);
  var listSuggestions = useMemo(() => {
    return suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((suggest, index) => {
      var boldedSearchSuggestion = boldCurrentSearchBarValueStr(suggest, searchBarValue);
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: classes.suggestItem
      }, /*#__PURE__*/React.createElement("button", {
        onClick: e => {
          mseSuggestionClick(e);
          handleSuggestion(suggest);
        },
        className: classes.suggestLink
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: boldedSearchSuggestion
        }
      })));
    });
  }, [suggestions]);
  var listProducts = items === null || items === void 0 ? void 0 : items.map(item => /*#__PURE__*/React.createElement(AutocompleteItem, {
    key: item.id,
    item: item,
    productClick: mseProductClick
  }));
  if (!openSearchBar) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: outWrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.closeSearchContainer
  }, /*#__PURE__*/React.createElement("button", {
    onClick: closeAutocomplete
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.close
  }, closeIcon))), /*#__PURE__*/React.createElement("div", {
    className: classes.innerRoot
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.innerContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.rightAutocomplete
  }, items !== null && items !== void 0 && items.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.labelTitle
  }, searchBarValue ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "filter.products.label",
    defaultMessage: "Products"
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "rending.products.label",
    defaultMessage: "Trending Products"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.items
  }, listProducts)) : loading ? /*#__PURE__*/React.createElement(LoadingIndicator, null) : null), /*#__PURE__*/React.createElement("div", {
    className: classes.leftAutocomplete
  }, searchBarValue ? /*#__PURE__*/React.createElement(React.Fragment, null, isMaxMobile && /*#__PURE__*/React.createElement("button", {
    className: classes.shopAll,
    onClick: () => {
      handleSuggestion(searchBarValue);
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "filter.shop.all",
    defaultMessage: "Shop All"
  })), !!(suggestions !== null && suggestions !== void 0 && suggestions.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.labelTitle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "filter.suggestions.label",
    defaultMessage: "Suggestions"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.itemsSuggestions
  }, listSuggestions)), !!(matchingCategories !== null && matchingCategories !== void 0 && matchingCategories.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.labelTitle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "filter.category.label",
    defaultMessage: "Category"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.itemsSuggestions
  }, matchingCategories.map(cat => {
    var title = boldCurrentSearchBarValueStr(cat.name, searchBarValue);
    return /*#__PURE__*/React.createElement("div", {
      key: cat.id,
      className: classes.suggestItem
    }, /*#__PURE__*/React.createElement(BBLink, {
      to: "/".concat(cat.url_path, ".html"),
      onClick: () => {
        setOpenSearchBar(null);
        mseCategoryClick(cat.name);
      },
      className: classes.suggestLink
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: title
      }
    })));
  }))), !isMaxMobile && /*#__PURE__*/React.createElement("button", {
    className: classes.shopAll,
    onClick: () => handleSuggestion(searchBarValue)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "filter.shop.all",
    defaultMessage: "Shop All"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, !!(listPopularSearch !== null && listPopularSearch !== void 0 && listPopularSearch.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.labelTitle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "filter.popular.label",
    defaultMessage: "Popular Searches"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.itemsSuggestions
  }, listPopularSearch)), !!(listSearches !== null && listSearches !== void 0 && listSearches.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.labelTitle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "filter.recent.label",
    defaultMessage: "Recent Searches"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.itemsSuggestions
  }, listSearches)))))));
};
export default Autocomplete;
Autocomplete.propTypes = {
  classes: shape({
    innerRoot: string,
    close: string,
    labelTitle: string,
    leftAutocomplete: string,
    rightAutocomplete: string,
    itemContent: string,
    ratingSection: string,
    suggestItem: string,
    suggestLink: string,
    itemsSuggestions: string,
    shopAll: string
  })
};